/** @format */

import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { KnowledgeBaseRating } from 'src/components/knowledegeBase/rating';
import LoadingScreen from 'src/components/LoadingScreen';
import Page from 'src/components/Page';
import { getKnowledgeBase, getKnowledgeBaseDetail } from 'src/slices/knowledgeBase';
import { useDispatch, useSelector } from 'src/store';
import { ContentBlock } from '../legal-pages/contentBlock';

export default function KnowledgeBaseDetail() {
  const dispatch = useDispatch();
  const { nid, kb } = useParams();
  const { error, globalLoading } = useSelector(state => state.global);
  const {
    knowledgeBaseDetail,
    knowledgeBaseDetailLoading,
    knowledgeBase,
    error: knowledgeBaseError
  } = useSelector(state => state.knowledgeBase);

  useEffect(() => {
    if (kb) dispatch(getKnowledgeBase(kb));
  }, [kb, dispatch]);

  useEffect(() => {
    if (!nid) return;
    dispatch(getKnowledgeBaseDetail(nid, false));
  }, [nid, dispatch]);

  const { title: pageTitle, rating, ratingCount, categories } = knowledgeBaseDetail || {};

  if (error || knowledgeBaseError || !nid) return <Navigate to="/404" replace />;
  if (globalLoading || knowledgeBaseDetailLoading || !knowledgeBase) return <LoadingScreen />;
  if (knowledgeBase) {
    return (
      <Page className={`knowledge-base`} title={pageTitle}>
        <Breadcrumb data={[{ title: knowledgeBase.title, link: `/knowledge-base/${kb}` }, { title: pageTitle }]} />
        <Grid className="container">
          <Grid className="content-container container">
            <Grid className="knowledge-base-title-box">
              <h1 className="knowledge-base-title">{pageTitle}</h1>
            </Grid>
            <Grid className="knowledge-base-rating">
              <KnowledgeBaseRating rating={rating} />
              {rating && (
                <Grid className="knowledge-base-rating-count">
                  {rating.toFixed(1)} | {ratingCount} Ratings
                </Grid>
              )}
            </Grid>
            {categories && (
              <Grid className="knowledge-base-content-categories">
                {categories.map((cat: string) => (
                  <Grid key={cat} className="knowledge-base-content-categories-item">
                    {cat}
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
          <Grid className="knowledge-base-content">
            {knowledgeBaseDetail && <ContentBlock nid={nid} kb={kb} content={knowledgeBaseDetail} />}
          </Grid>
        </Grid>
      </Page>
    );
  }

  return null;
}
